import PropTypes from "prop-types";
import { useState } from "react";
import { IconSearch, IconX } from "@tabler/icons";

export const TemplateSearchBar = (props) => {
  const { onTagsChange, placeholder } = props;
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState([]);

  const addTag = (val) => {
    const trimmed = val.trim();
    if (trimmed && !tags.includes(trimmed)) {
      const updated = [...tags, trimmed];
      setTags(updated);
      onTagsChange(updated);
    }
    setInputValue("");
  };

  const removeTag = (tag) => {
    const updated = tags.filter((t) => t !== tag);
    setTags(updated);
    onTagsChange(updated);
  };

  const clearAll = () => {
    setTags([]);
    setInputValue("");
    onTagsChange([]);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag(inputValue);
    } else if (e.key === "Backspace" && inputValue === "" && tags.length > 0) {
      removeTag(tags[tags.length - 1]);
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.includes(",")) {
      val.split(",").forEach((part) => part.trim() && addTag(part));
    } else {
      setInputValue(val);
    }
  };

  return (
    <div className="flex items-center flex-wrap gap-[6px] min-h-[40px] w-full border border-[#d5d7db] rounded-[6px] bg-white px-[10px] py-[6px] cursor-text focus-within:border-[#0057ff] focus-within:ring-2 focus-within:ring-[#0057ff]/20 transition-all">
      <IconSearch size={16} className="text-[#9fa3ad]" stroke={2} />

      {tags.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center gap-[4px] bg-[#eff0f7] text-[#2e384d] rounded-[4px] px-[8px] py-[2px] text-[12px] font-['Rubik:Regular',sans-serif] shrink-0"
        >
          {tag}
          <button
            type="button"
            onClick={() => removeTag(tag)}
            className="text-[#9fa3ad] hover:text-[#2e384d] transition-colors"
            aria-label="Remove tag"
          >
            <IconX size={11} />
          </button>
        </span>
      ))}

      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={tags.length === 0 ? placeholder : ""}
        className="flex-1 min-w-[140px] outline-none bg-transparent text-[#2e384d] text-[13px] font-['Rubik:Regular',sans-serif] placeholder:text-[#9fa3ad]"
      />

      {(inputValue || tags.length > 0) && (
        <button
          type="button"
          onClick={clearAll}
          className="text-[#9fa3ad] hover:text-[#2e384d] transition-colors shrink-0 ml-auto"
          aria-label="Remove tag"
        >
          <IconX size={16} />
        </button>
      )}
    </div>
  );
};

TemplateSearchBar.propTypes = {
  onTagsChange: PropTypes.func,
  placeholder: PropTypes.string,
};

TemplateSearchBar.defaultProps = {
  onTagsChange: () => {},
  placeholder: "Search templates, separate terms with commas",
};